import React from 'react'
import { cn } from '@scalis/utils/src'
import { statusTagStyle } from './status-tag.styles'
import { StatusStyleOption, StatusTagColors, StatusTagProps } from './status-tag.types'

export const StatusTag: React.FC<StatusTagProps> = ({
  text,
  status = StatusTagColors.green,
  className,
  contentContainerClassName,
  statusIconClassName,
  small,
  endAdornment,
  ...props
}) => {
  const { contentContainer, tag, textContent, statusIcon } = statusTagStyle({
    status: status as StatusStyleOption,
    small,
  })

  const [customColor, setCustomColor] = React.useState('')

  React.useEffect(() => {
    if (status === StatusTagColors.custom) {
      setCustomColor(props.customColor ?? '')
    }
  }, [status, props.customColor])

  const customColorStyle = { style: { backgroundColor: customColor } }

  return (
    <div className={tag({ class: className })}>
      <div className={contentContainer({ class: contentContainerClassName })}>
        <span
          className={cn(statusIcon({ class: statusIconClassName }), props.customColor)}
          aria-label={props['aria-label']}
          role='img'
          {...customColorStyle}
        />
        <div
          data-testid='status-tag-text'
          className={textContent()}
          aria-label={props['aria-label']}
        >
          {text}
        </div>
        {endAdornment && (
          <i
            aria-hidden
            aria-label='endAdornment'
            className={cn(endAdornment, 'fa-xs')}
          />
        )}
      </div>
    </div>
  )
}
